import { useSelector } from 'react-redux';
import _get from 'lodash/get';

export default function useIsAdmin() {
  return useSelector(state => _get(state, 'authentication.person.account.isAdmin', false));
}
